import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Amber gradient top bar */}
      <div className="footer-top-bar" />

      <div className="footer-inner">
        {/* ── Col 1: Brand ── */}
        <div className="footer-col footer-brand">
          <a href="/" className="footer-logo">
            <span className="footer-logo-vetri">VETRI</span>
            <span className="footer-logo-realtors">REALTORS</span>
          </a>
          <p className="footer-tagline">
            Premium Real Estate Solutions along ECR &amp; OMR — trusted by families &amp; investors since 2025.
          </p>
          <div className="social-icons">
            {[
              { href: '/', icon: 'fab fa-facebook-f', label: 'Facebook' },
              { href: '/', icon: 'fab fa-instagram', label: 'Instagram' },
              { href: '/', icon: 'fab fa-linkedin-in', label: 'LinkedIn' },
              { href: '/', icon: 'fab fa-twitter', label: 'Twitter' },
              { href: '/', icon: 'fab fa-whatsapp', label: 'WhatsApp' },
            ].map(({ href, icon, label }) => (
              <a key={label} href={href} className="social-icon" aria-label={label}>
                <i className={icon} />
              </a>
            ))}
          </div>
        </div>

        {/* ── Col 2: Quick Links ── */}
        <div className="footer-col">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-list">
            {[
              { href: '/', label: 'Home' },
              { href: '/listings', label: 'Properties' },
              { href: '/about', label: 'About Us' },
              { href: '/contact', label: 'Contact' },
            ].map(({ href, label }) => (
              <li key={label}>
                <a href={href} className="footer-link">
                  <span className="footer-link-arrow">›</span> {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Col 3: Services ── */}
        <div className="footer-col">
          <h3 className="footer-heading">Our Services</h3>
          <ul className="footer-list">
            {[
              'Farm Land Transactions',
              'Residential Plots',
              'Legal Documentation',
              'Property Registration',
              'ECR / OMR Properties',
              'Investment Advisory',
            ].map((s) => (
              <li key={s}>
                <span className="footer-service-dot" />
                {s}
              </li>
            ))}
          </ul>
        </div>

        {/* ── Col 4: Contact ── */}
        <div className="footer-col footer-contact">
          <h3 className="footer-heading">Get In Touch</h3>
          <ul className="footer-contact-list">
            <li>
              <i className="fas fa-map-marker-alt footer-icon" />
              <span>No.2, Thriram, ECR, Kovalam, Chennai</span>
            </li>
            <li>
              <i className="fas fa-phone-alt footer-icon" />
              <a href="tel:+918438623133" className="contact-link">+91 84386 23133</a>
            </li>
            <li>
              <i className="fas fa-envelope footer-icon" />
              <a href="mailto:vetrirealtorspvtltd@gmail.com" className="contact-link">
                vetrirealtorspvtltd@gmail.com
              </a>
            </li>
            <li>
              <i className="fas fa-clock footer-icon" />
              <span>Mon – Sat: 9 AM – 7 PM</span>
            </li>
          </ul>

          <a href="tel:+918438623133" className="footer-cta-btn">
            <i className="fas fa-phone-alt" /> Call Now
          </a>
        </div>
      </div>

      {/* ── Legal bar ── */}
      <div className="footer-legal">
        <p className="footer-legal-ids">
          CIN: U68200TN2025TC18545 &nbsp;|&nbsp; TAN: CHEV26094F &nbsp;|&nbsp; PAN: AALCV261IC
        </p>
        <p className="footer-copyright">
          &copy; {currentYear} Vetri Realtors Pvt Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;